export default __webpack_public_path__ + "static/media/mac-app-logo-128@4x.674a1c54.png";